import Vue from 'vue'
import App from './App.vue'
import router from './router'


import logo from '@/assets/aa.png'
import VueLazyload from 'vue-lazyload' 
Vue.use(VueLazyload,{
  loading:logo
})
// import './config/rem'
import './plugins/element.js'

import axios from 'axios'
import {
  Utils
} from './api/utilPort'
// 样式
import '@/assets/css/global.css'
import "./assets/iconfont/iconfont.css"


// axios
// axios.defaults.baseURL = ''
Vue.prototype.$http = axios
Vue.config.productionTip = false
import Header from '@/components/Header.vue'
Vue.component(Header.name,Header)
const cancelDefaltList = ['/course/','/course/**']
Vue.prototype.$currentHttpRequestList = new Map();
Vue.prototype.$cancelRequest = function(cancelkey) {
  if (cancelkey) {
    if (cancelkey.indexOf('/**') > -1) {
      Vue.prototype.$currentHttpRequestList.forEach((item, key) => {
        key.indexOf(cancelkey.split('/**')[0]) > -1 && item('Operation canceled by the user.');
      });
    } else {
      Vue.prototype.$currentHttpRequestList.get(cancelkey) && Vue.prototype.$currentHttpRequestList.get(cancelkey)('Operation canceled by the user.');
    }
  } else {
    cancelDefaltList.forEach(eachWite => {
      Vue.prototype.$currentHttpRequestList.forEach((item, key) => {
      key.indexOf(eachWite.split('/**')[0]) > -1 && item('Operation canceled by the user.')
      })
    })
 }
}


new Vue({
  router,
  render: h => h(App),
  beforeCreate(){
    Vue.prototype.$bus = this
  }
}).$mount('#app')
